class CustomizeModal extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('click', this.onRemoveDiamond.bind(this));
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.diamondsQuantityField = this.querySelector('#diamonds-quantity');
        this.diamondsQuantityField.addEventListener('change', this.onDiamondsQuantityChange.bind(this));
        this.addDiamondLink = this.querySelector('[data-add-diamond]');
        this.addDiamondLink.addEventListener('click', this.onAddDiamond.bind(this));
        this.rowEnd = this.querySelector('[data-row-diamonds-end]');

        this.rowTemplate = this.querySelector('[data-row-diamonds-template]').innerHTML;
    }

    onAddDiamond(evt) {
        evt.preventDefault();
        console.log('add diamond row');
        this.addDiamondRow();
        this.updateNumberOfDiamonds();
    }

    onRemoveDiamond(evt) {
        if (evt.target.matches('[data-remove-diamond-row]')) {
            evt.preventDefault();
            let index = evt.target.dataset.removeDiamondRow;
            this.removeDiamondRow(index);
            this.updateNumberOfDiamonds();
        }
    }

    onDiamondsQuantityChange(evt) {
        const qty = parseInt(evt.target.value);
        const rows = this.querySelectorAll('.row-diamonds:not(.row-diamonds-template)');
        let index = rows.length;
        if(index > 0) {
            if(qty > index) {
                for (let step = index; step < qty; step++) {
                    this.addDiamondRow();
                }
            } else if(qty < index && index > 1) {
                for (let step = index; step > qty; step--) {
                    this.removeDiamondRow(step);
                }
            }
        }
    }

    removeDiamondRow(index) {
        let rowToRemove = this.querySelector('[data-row-diamond="'+index+'"]');
        if(rowToRemove) {
            rowToRemove.remove();
        }

    }

    addDiamondRow() {
        const rows = this.querySelectorAll('.row-diamonds:not(.row-diamonds-template)');
        let index = rows.length ? rows.length + 1 : 0;
        if(index > 0) {
            let row = this.rowTemplate.replaceAll('index',index).replace(' row-diamonds-template','');
            this.rowEnd.insertAdjacentHTML('beforebegin',row);
        }
    }

    updateNumberOfDiamonds() {
        const rows = this.querySelectorAll('.row-diamonds:not(.row-diamonds-template)');
        this.diamondsQuantityField.value = rows.length;
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        this.cartNotification.setActiveElement(document.activeElement);

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => response.json())
            .then((parsedState) => {
                this.cartNotification.renderContents(parsedState);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
            });
    }
}

customElements.define('customize-modal', CustomizeModal);
